import { Box, Typography, styled, IconButton, Icon, Button } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Link } from "@mui/material";
import { IconTextButton } from "./IconTextButton";
import { MediaTile } from "./MediaTile";
import { useEffect, useState } from "react";
import { getEvents } from "requests/getEvents";
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material"

// import './styles.css';

const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  min-height: 120px;
  width: 100%;
  box-sizing: border-box;
  z-index: 100;
  background-color: black;
`;

const Guy = styled(Box)`
  padding: 10px;
  font-family: "Caveat", serif;
  color: white;
  justify-content: space-evenly;
  display: flex;

  h1 {
    font-size: 50px;
    font-weight: bold;
    margin: 0;
  }
`;

const Layout = styled(Box)`
  margin-top: 100px;
  box-sizing: border-box;
  width: 100%;
  min-height: calc(100vh - 100px);
  // border: 1px solid yellow;
  display: flex;
  flex-direction: column;
`;

const PageContent = styled(Box)`
  box-sizing: border-box;
  // border: 1px solid orange;
`;

const DistrokidLink = styled(Link)`
<style>
    display: flex;
    justify-content: space-evenly;
    color: white;
    cursor: pointer;
    text-decoration: none;
    font-size: 1.5rem;
    background-color: transparent;
    &:hover {
        text-decoration: underline;
    }
    &:visited {
    color: white;
    }
</style>
}`;

const Hero = styled(Box)`
    width: 100%;
    background-image: url(/heroimage.JPG);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    box-sizing: border-box;
    height: 880px;
    max-height: 880px;
    top: 0;
    left: 0;
    max-width: 100%;
    z-index: 100;
    margin-top: -100px;
}
`;

const Action = styled(Box)`
  //justify-content: space-evenly;
  // text-align: center;
  // position: absolute;
  border: 0px solid green;
  width: 100vw;
  min-height: 1110px;
  // max-height: 500px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  background: url(image5.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  // -webkit-filter: blur(6px);
  padding-bottom: 50px;
  z-index: ;
  border: ;
`;

const AlbumRetreat = () => (
  <Link
    href="https://open.spotify.com/album/72j51zRB9234Ya5njSOYlc"
    sx={{ display: "block", textAlign: "center" }}
    underline="none"
  >
    <Box
      sx={{
        transition: "0.3s ease-in-out",
        transform: {
          xs: "scale(1)",    // default size on mobile
          md: "scale(1.05)", // slightly larger on medium+
          lg: "scale(1.1)",  // more on large screens
        },
        "&:hover": {
          filter: "brightness(70%)",
        },
      }}
    >
    <MediaTile image="url(smallretreat.jpeg)" text="Retreat" />
    </Box> 
  </Link>
);

const AlbumHorse = () => (
  <Link
    href="https://open.spotify.com/album/4yYTWwTBRF9ws4gpyx1ZEc"
    sx={{ display: "block", textAlign: "center" }}
    underline="none"
  >
    <Box
      sx={{
        transition: "0.3s ease-in-out",
        transform: {
          xs: "scale(1)",    // default size on mobile
          md: "scale(1.05)", // slightly larger on medium+
          lg: "scale(1.1)",  // more on large screens
        },
        "&:hover": {
          filter: "brightness(70%)",
        },
      }}
   >    
    <MediaTile image="url(cripplehorse1.jpeg)" text="Cripple Horse" />
    </Box>
  </Link>
);

const GigContainer = styled(Box)`
  padding: 1.5rem;
  box-sizing: border-box;
  border: 2px solid grey;
  width: 90%;
  justify-content: center;
  margin: auto;
  margin-bottom: 0px;
  margin-top: 25px;
  border-radius: 15px;
  color: white;
  min-height: 120px;

 .MuiBox-root {
    margin-bottom: 1rem;
  }
`;

const MoreInfoDialog = ({ open, onClose, details, location, venue }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Event Details</DialogTitle>
    <DialogContent>
      <Typography>{details}</Typography>
      <br/>
      {[venue,
        location.city, 
        location.street,
        location.zip]
        .filter((row) => row?.trim()!=="")
        .map((row) => <Typography key={row}>{row}</Typography>)
      }
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">Close</Button>
    </DialogActions>
  </Dialog>
);

const GigBox = ({ venue, date, time, details, location }) => {
  const [open, setOpen] = useState(false);

  return (
    <GigContainer>
      <Box
  sx={{
    display: "flex",
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    justifyContent: "space-between",
    alignItems: "center",
    gap: 2,
    width: "100%",
    textAlign: {
      xs: "center",
      sm: "left",
    },
  }}
>
  {/* Left: Date + Venue */}
  <Box sx={{ flex: 1 }}>
    <Box>{date}</Box>
    <Box sx={{ fontWeight: "bold" }}>{venue}</Box>
    {location?.city && <Box>{location.city}</Box>}
  </Box>

  {/* Center: Button */}
  <Box
    sx={{
      flex: 1,
      display: "flex",
      justifyContent: "center",
    }}
  >
    <Button
      variant="contained"
      sx={{
        backgroundColor: "white",
        color: "black",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "	#A9A9A9",
        },
      }}
      onClick={() => setOpen(true)}
    >
      More Info
    </Button>
  </Box>

  {/* Right: Time */}
  <Box sx={{ flex: 1, textAlign: "right", fontWeight: "bold" }}>{time}</Box>
</Box>


      <MoreInfoDialog open={open} onClose={() => setOpen(false)} details={details} location={location} venue={venue} />
    </GigContainer>
  );
};

const Gigs = () => {
  const [events, setEvents] = useState ([]);

  useEffect(() => {
    const applyEvents = async () => {
      setEvents(await getEvents())
    }

    applyEvents();

  },[]) 

  return (
    <div>
      {events.map((item) => {
        const eventDate = new Date(item.start_time);
        const formattedDate = eventDate.toLocaleDateString();
        const formattedTime = eventDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        const description = item.description || "No additional info available.";
        return <GigBox key={item.id} venue={item.place.name} date={formattedDate} time={formattedTime} details={description} location={item.place.location}/>;
      })}
    </div>
  );
};

const Footer = styled(Box)`
  margin-top: auto;
  min-height: 100px;
  box-sizing: border-box;
  border-top: 1px solid white;
  border-bottom: 0px;
  border-style: solid none;
  z-index: 250;
  background-color: black;
`;

export const Page = (props) => (
  <Box>
    <Header>
  <Guy>
    <h1>Guy North</h1>
  </Guy>
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "50px", // Space between "Listen now" and the icons
    }}
  >
    <DistrokidLink href="https://distrokid.com/hyperfollow/guynorth/retreat" 
      sx={{ fontSize: "1.5rem", fontWeight: "bold", }}
    >
      Listen now
    </DistrokidLink>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "2px", // Space between the icons
      }}
    >
      <IconButton
            component="a"
            href=""
            sx={{
              padding: 0, // Removes extra padding (circle effect)
            }}
          >
            <EmailIcon sx={{ fontSize: "30px", color: "white" }} />
          </IconButton>
          <IconButton
            component="a"
            href=""
            sx={{
              padding: 0,
              backgroundColor: "transparent",
              transition: "0.3s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              },
            }}
          >
            <InstagramIcon sx={{ fontSize: "30px", color: "white" }} />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.facebook.com/guynorthmusic"
            sx={{
              padding: 0,
              backgroundColor: "transparent",
              transition: "0.3s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              },
            }}
          >
            <FacebookIcon sx={{ fontSize: "30px", color: "white" }} />
          </IconButton>
        </Box>
      </Box>
    </Header>


    <Layout>
      <PageContent>{props.children}</PageContent>
      <Hero/>

      <Action>

       <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",     
            boxSizing: "border-box",
            paddingTop: "3%",
            paddingBottom: "1%",
          }}
       >
          <Typography
            variant="body2"
            color="white"
            fontWeight="bold"
            fontSize="30px"
          >
            Gigs
          </Typography>
        </Box>
        <Gigs/>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "4%",
            paddingBottom: "4px",
            flexWrap: "wrap",
            gap: {
              xs: "24px",
              sm: "40px",
              md: "80px",
              lg: "100px",  
            },
          }}
        >
          <AlbumRetreat />
          <AlbumHorse />
        </Box>
      </Action>
      <Footer>
  <Box
    sx={{
      height: "100%", // ensure it uses the full footer height
      display: "flex",
      justifyContent: "space-around", // or "center" if you want them tightly centered
      alignItems: "center", // vertically center the items
      paddingY: "30px", // optional vertical padding
      "& .MuiTypography-root": {
        fontWeight: "bold",
      },
    }}
  >
    <IconTextButton
      icon={<EmailIcon />}
      text="Get in touch"
      href=""
      sx={{
        display: "flex", // Always display the icon
        flexDirection: "row",
        gap: "8px",
        "& .MuiTypography-root": {
          display: { xs: "none", sm: "inline" }, // Hide text on mobile, show on larger screens
        },
      }}
    />
    <IconTextButton
      icon={<InstagramIcon />}
      text="Follow me on Instagram"
      href=""
      sx={{
        display: "flex", // Always display the icon
        flexDirection: "row",
        gap: "8px",
        "& .MuiTypography-root": {
          display: { xs: "none", sm: "inline" }, // Hide text on mobile, show on larger screens
        },
      }}
    />
    <IconTextButton
      icon={<FacebookIcon />}
      text="Follow me on Facebook"
      href="https://www.facebook.com/guynorthmusic"
      sx={{
        display: "flex", // Always display the icon
        flexDirection: "row",
        gap: "8px",
        "& .MuiTypography-root": {
          display: { xs: "none", sm: "inline" }, // Hide text on mobile, show on larger screens
        },
      }}
    />
      </Box>
    </Footer>
  </Layout>
</Box>
);